const COOKIE_NAME = 'selectedCountry';
const COOKIE_MAX_AGE = 30 * 24 * 60 * 60;
export const COUNTRY_CHANGE_EVENT = 'countryCookieChange';

export function getCountryCookie(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function setCountryCookie(countryCode: string): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(countryCode.toUpperCase())};path=/;max-age=${COOKIE_MAX_AGE};SameSite=Lax`;
  window.dispatchEvent(new CustomEvent(COUNTRY_CHANGE_EVENT, { detail: countryCode.toUpperCase() }));
}

export function removeCountryCookie(): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${COOKIE_NAME}=;path=/;max-age=0`;
  window.dispatchEvent(new CustomEvent(COUNTRY_CHANGE_EVENT, { detail: null }));
}
